export default {
  response: {
    organisationName: '',
    personalName: ''
  },
  errors: { getNameByInn: null },
  loading: {
    getOrganisationName: false,
    getPersonalName: false
  },
  flags: {
    isEditPersonalName: false,
    isEditOrganisationName: false
  }
}
